export class Payout {
  customer_rate: number;
  rate: number;
  type: string;
  currency: string;
  amount: number;
  partner_id: string;
  branch_code: string;
  bank_account: string;
  bank_code: string;
}

export const PayoutType = {
  'AccountDeposit': 'Account deposit',
  // 'AccountDepositOtherBank': 'Account deposit to Other Bank',
  'Cash': 'Cash Payment',
  'CardCredits' : 'Credit Card',
  'E_Wallet': 'E-Wallet',
  'EWallet': 'E-Wallet',
  'HomeDelivery': 'HomeDelivery',
  'Mobile': 'Mobile',
  'RDA' : 'Roshan Digital Account Deposit',
};

export class PayoutTypeValues {
  list = PayoutType;
  getList(): Array<string> {
    const list = Object.keys(this.list);
    list.splice(list.indexOf('EWallet'), 1);
    return list;
  }
}



// WEBPACK FOOTER //
// ./src/app/model/shared/transaction/payout.ts